import {
  BarChartOutlined,
  FormOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Avatar, Layout, Menu, Space } from 'antd'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { extractSectionFromPath } from '../../helpers/RouterHelper'
import RightHeader from './RightHeader'
import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import { useAppSelector } from '../../store/hooks'
import { selectSelectedProfile } from '../../store/ProfileReducer'

const { Header } = Layout

interface Props {
  subItems?: ItemType<MenuItemType>[] | undefined
}

const MainHeader = ({ subItems }: Props) => {
  const { pathname } = useLocation()
  const profile = useAppSelector(selectSelectedProfile())

  const [selectedKey, setSelectedKey] = useState<string>('events')
  const [selectedSubKey, setSelectedSubKey] = useState<string>('contacts')

  const headerStyle: React.CSSProperties = {
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    paddingRight: 20,
    paddingLeft: 20,
  }

  const subHeaderStyle: React.CSSProperties = {
    backgroundColor: '#e6e6e6',
    justifyContent: 'space-between',
    display: 'flex',
    paddingRight: 20,
    paddingLeft: 20,
    height: 50,
    lineHeight: '50px',
  }

  useEffect(() => {
    setSelectedKey(extractSectionFromPath(pathname, 1))
    setSelectedSubKey(extractSectionFromPath(pathname, 2))
  }, [pathname])

  return (
    <div className={'fixed z-20 w-full'}>
      <Header style={headerStyle} className="bg-header">
        <Space direction="horizontal" className="space-between w-full ">
          <Space direction="horizontal">
            <div className="logo-container">
              <Link to="/">
                <img
                  style={{ marginTop: 30, marginRight: 30 }}
                  src="/assets/images/logos/regular/pink.png"
                  height={45}
                />
              </Link>
            </div>
          </Space>
          <RightHeader />
        </Space>
      </Header>
      {subItems && (
        <Header style={subHeaderStyle}>
          <div
            style={{
              maxWidth: 1200,
              width: '100%',
              margin: 'auto',
            }}
          >
            <Menu
              style={{ background: '#e6e6e6', border: 'none' }}
              className="d-flex-lg"
              mode="horizontal"
              selectedKeys={[selectedSubKey]}
              items={subItems}
            />
          </div>
        </Header>
      )}
    </div>
  )
}

export default MainHeader
